document.addEventListener('alpine:init', () => {
    Alpine.data('CurrencySwitcher', (data) => {

        return {
            currencies: data.currencies,
            selectedCurrency: data.selectedCurrency,
            open: false,
            async changeCurrency(currency) {
                this.selectedCurrency = currency;
                this.open = false;

                try {
                    await fetch(
                        `/?wc-ajax=change_currency&currency=${currency.id}`,
                        {
                            credentials: 'include',
                        },
                    );
                } catch (ex) {
                    console.error(ex);
                }

                if (document.location.pathname === '/klarna/') {
                    document.location.href = '/klarna/';
                } else {
                    document.location.reload();
                }
            },
        };
    });
});
